import axios from 'axios';
import client from './feathers';

export function uploadFiles(dbName, file) {
  const formData = new FormData();
  formData.append('files', file);
  const res = axios.post(`/newUploads?type=${dbName}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      authorization: localStorage.getItem('feathers-jwt'),
    },
  });
  return res;
}

export const deleteFile = (file) => {
  console.log({ delete: file });
  return client.service('uploads').remove(file.response._id);
};
